import React from "react";
import { motion } from "framer-motion";
import { Box } from "@mui/material";

function AnimatedText({ text }) {
  const letters = text
    .split("")
    .map((char) => (char === " " ? "\u00A0" : char));

  const letterAnim = {
    hidden: { opacity: 0, x: 40 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: 0.15 + i * 0.035,
        duration: 0.5,
        ease: "easeOut",
      },
    }),
  };

  return (
    <Box
      sx={{
        fontWeight: 700,
        fontSize: { xs: "2rem", md: "2.4rem" },
        textTransform: "uppercase",
        letterSpacing: "0 em", // Even tighter spacing
        display: "flex",
        justifyContent: "center",
        gap: "0.02em", // Reduce gap between letters
        textShadow: "2px 4px 14px rgba(50,50,60,0.17), 0 1px 0 #fff",
      }}
      component="h1"
    >
      {letters.map((char, i) => (
        <motion.span
          key={i}
          custom={i}
          variants={letterAnim}
          initial="hidden"
          animate="visible"
          style={{
            display: "inline-block",
            whiteSpace: "pre",
          }}
        >
          {char}
        </motion.span>
      ))}
    </Box>
  );
}

export default AnimatedText;
